export default {
  pedido: {},
  pedidos: [],
  pagination: {
    current_page: 1,
    last_page: 1,
    from: 1,
    to: 1,
    per_page: 15,
    total: 0,
  },
  error: {},
};
